import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api/apiServises';
import {
  MAIN_DASHBOARD,
  SHELL_DASHBOARD,
  BOGGIE_DASHBOARD,
  WHEEL_DASHBOARD,
  FURNISHING_MODULE_DASHBOARD,
} from '../../../api/apiConstant';

export const fetchDashboardCounts = createAsyncThunk(
  'dashboard/fetchDashboardCounts',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(MAIN_DASHBOARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch dashboard counts',
      );
    }
  },
);
export const fetchShellDashboard = createAsyncThunk(
  'dashboard/fetchShellDashboard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(SHELL_DASHBOARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch dashboard counts',
      );
    }
  },
);

export const fetchWheelDashboard = createAsyncThunk(
  'dashboard/fetchWheelDashboard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(WHEEL_DASHBOARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch wheel dashboard',
      );
    }
  },
);

export const fetchBoggieDashboard = createAsyncThunk(
  'dashboard/fetchBoggieDashboard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(BOGGIE_DASHBOARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch wheel dashboard',
      );
    }
  },
);

export const fetchFurnishingDashboard = createAsyncThunk(
  'dashboard/fetchFurnishingDashboard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(FURNISHING_MODULE_DASHBOARD, { params: formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch wheel dashboard',
      );
    }
  },
);
